import { FC } from "react";
import { ROUTES } from "constants/routes";
import { AuthLayout } from "layouts/AuthLayout";
import { ResetPassword } from "features/ResetPassword";

const ResetPasswordPage: FC = () => (
  <AuthLayout backRoute={ROUTES.signIn}>
    <ResetPassword />
  </AuthLayout>
);

export default ResetPasswordPage;
